import { useLiveQuery } from '@sanity/preview-kit';
import { FC } from 'react';
import postQuery from '@/src/assets/queries/postQuery';
import { IPost } from '@/src/assets/interfaces/postInterface';
import Post from '../../screens/post/Post';


interface PreviewPostPageProps {
  data: Partial<IPost>;
  slug: string;
}

const PreviewPostPage: FC<PreviewPostPageProps> = ({ data, slug }) => {
  const [postData] = useLiveQuery(data, postQuery(slug));

  return <Post postData={postData} />;
};

export { PreviewPostPage };
